import axios from 'axios'
import store from '../story/'
import { ossUrl} from '../config/env'
import * as mobile from './../config/mUtils'

let searchParams = (prop) => {
  let param = new FormData();
  for (let key in prop) {
    param.append(key, prop[key])
  }
  return param
};
let searchParams2 = (prop) => {
  let param = [];
  for (let key in prop) {
    param.push(`${key}=${prop[key]}`);
  }
  return param.join('&')
};

axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  config.params = Object.assign({time: new Date().getTime()}, config.params);
  config.headers['token'] = store.state.parkToken || mobile.getStore('parkToken');
  config.headers['phone'] = store.state.userPhone || mobile.getStore('userPhone');
  config.headers['channelId'] = store.state.channelId || mobile.getStore('channelId');
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

//添加一个响应拦截器
axios.interceptors.response.use(function (res) {
  /*if (res.data.code === 2) {
    router.replace({path:'/login'})
    mobile.removeStore('parkToken');
    store.state.parkToken=''
    mobile.removeStore('userPhone');
    store.state.userPhone=''
    return res;
  }*/
  if (res.headers && (res.headers['content-type'] === 'application/x-msdownload' || res.headers['content-type'] === 'application/vnd.ms-excel')) {
    downloadUrl(res.request.responseURL);
    return {data: {code: 1}}
  }
  return res;
}, function (err) {
  //Do something with response error
  return Promise.reject(err);
});

/**
 * 获取企业移动端url
 * 参数名	必选	类型	说明
 * url	是	string	域名
 */
var getChannelByUrl = (url) => axios.get('/api/user/getChannelByUrl?url=' + url);

/**
 * 身份认证
 * realName 真实名字 可以不传，用当前名字
 * idCardNum 身份证号码
 * userPhone 电话
 * code 验证码
 * front 身份证正面
 * back 反面
 */
var identityAuthentication = (idCardNum,userPhone,code,realName,front,back) => axios.post('/api/user/identityAuthentication', searchParams2({idCardNum: idCardNum,userPhone: userPhone,code: code,realName: realName,front: front,back: back}));

/**
 * 小组编辑页数据
 * groupId 小组id
 */
var groupInfo = (groupId) => axios.get('/api/group/groupInfo?groupId=' + groupId);

/**
 * 推荐课程
 * pageIndex	是	int	当前页码
 * pageSize	是	int	每页条数
 */
var courseRecommendList = (pageIndex, pageSize) => axios.get('/api/course/recommendList?pageIndex=' + pageIndex + '&pageSize=' + pageSize);

/**
 * 全部党课
 * pageIndex	是	int	当前页码
 * pageSize	是	int	每页条数
 * typeId	否	int	课程类型
 */
var courseAllList = (pageIndex, pageSize, typeId) => axios.get('/api/course/allList?pageIndex=' + pageIndex + '&pageSize=' + pageSize + '&typeId=' + typeId);

/**
 * 我的课程
 * pageIndex	是	int	当前页码
 * pageSize	是	int	每页条数
 */
var courseMyList = (pageIndex, pageSize) => axios.get('/api/course/myCourse?pageIndex=' + pageIndex + '&pageSize=' + pageSize);

/**
 * 我的课程(未完成 -不分页)
 */
var myCourseForIndex = () => axios.get('/api/course/myCourseForIndex');

/**
 * 党课类型列表
 */
var courseTypeList = () => axios.get('/api/course/courseTypeList');

/**
 * 课程详情
 * pageIndex	是	int	当前页码
 * pageSize	是	int	每页条数
 */
var courseDetail = (courseId) => axios.get('/api/course/detail?courseId=' + courseId);

/**
 *  更新学习次数
 * @param courseId
 * @returns {AxiosPromise}
 */
var courseUpLearn = (courseId) => axios.get('/api/course/upLearn?courseId=' + courseId);

/**
 * 添加到我的党课
 * courseId	是	id	课程id
 */
var addMyCourse = (data) => axios.post('/api/course/addMyCourse', searchParams2(data));

/**
 * 更新学习时长
 * courseId	是	id	课程id
 * courseDetailId	是	id	课程内容id(第几节课)
 * coursewareId	是	id	课件id
 * courseState	是	int	课程是否学习完毕(0 否 1是)
 * courseDetailState	是	int	课程内容是否学习完毕(0 否 1是)
 * coursewareState	是	int	课件是否学习完毕(0 否 1是)
 * learnTime	是	int	本次学习时长
 */
var addMyCourseTime = (data) => axios.post('/api/course/addMyCourseTime', searchParams2(data));

/**
 * 活动列表
 * pageIndex	是	int	当前页码
 * pageSize	是	int	每页条数
 * keyWord	否	String	活动标题
 */
var activityList = (pageIndex, pageSize, keyWord) => axios.get('/api/activity/activityList?pageIndex=' + pageIndex + '&pageSize=' + pageSize + '&keyWord=' + keyWord);

/**
 * 我的活动
 * pageIndex	是	int	当前页码
 * pageSize	是	int	每页条数
 * keyWord	否	String	活动标题
 */
var myActivity = (pageIndex, pageSize, keyWord) => axios.get('/api/activity/myActivity?pageIndex=' + pageIndex + '&pageSize=' + pageSize + '&keyWord=' + keyWord);

/**
 * 活动详情
 * activityId	是	int	活动id
 */
var activityDetail = (activityId) => axios.get('/api/activity/activityDetail?activityId=' + activityId);

/**
 * 检测用户和活动关系
 * activityId	是	int	活动id
 */
var checkUserActivityState = (activityId) => axios.get('/api/activity/checkUserActivityState?activityId=' + activityId);

/**
 * 活动报名
 * activityId	是	int	活动id
 * optionIds	是	Long[]	选项数组
 */
var signUp = (data) => axios.post('/api/activity/signUp', searchParams2(data));

/**
 * 专题类型列表
 */
var findTypeList = () => axios.get('/api/special/findTypeList');

/**
 * 专题列表
 * pageIndex	是	int	当前页码
 * pageSize	是	int	每页条数
 * typeId	是	int	类型
 * title	是	string	专题标题
 */
var topicList = (pageIndex, pageSize, typeId, title) => axios.get('/api/special/findList?pageIndex=' + pageIndex + '&pageSize=' + pageSize + '&typeId=' + typeId + '&title=' + title);

/**
 * 得到专题
 * specialId	是	long	专题标题id
 */
var topicDetail = (specialId) => axios.get('/api/special/findSpecial?specialId=' + specialId);

/**
 * 活动推荐列表
 * state	是	int	状态 三会一课状态（0 已取消 1 未开始 2 进行中 3 已结束 4 草稿）
 * keyword	否	String	关键词
 */
var meetingList = (state, keyword) => axios.get('/api/meeting/findList?state=' + state + '&keyword=' + keyword);

/**
 * 得到会议记录
 * meetingId	是	Long	Meeting对象主键
 */
var meetingDetail = (meetingId) => axios.get('/api/meeting/findMeeting?meetingId=' + meetingId);

/**
 * 用户签到
 * meetingId	是	long	会议id
 */
var addSign = (data) => axios.post('/api/meeting/addSign', searchParams2(data));

/**
 * 新增会议记录
 *

 private String meetingName;

 private Integer meetingState;

 private Date meetingStartTime;

 private Date meetingEndTime;

 private String meetingAddress;

 private Long meetingDutyUser;

 private Integer meetingJoinRange;

 private String meetingJoinRangeUserIds;

 private Integer meetingSummaryRange;

 private String meetingSummaryRangeUserIds;

 private Integer meetingIsPush;

 private Integer meetingIsSign;

 private Date meetingSignStartTime;

 private Date meetingSignEndTime;

 private String meetingVideoImg;

 private String meetingVideo;
 private String meetingText;
 */
var addMeeting = (data) => axios.post('/api/meeting/addMeeting', JSON.stringify(data), { headers: { 'Content-Type': 'application/json' }});

/**
 * 专题列表 查找党支部和人员
 */
var findUserInfoByBranch = () => axios.post('/api/user/findUserInfoByBranch');

/**
 * 提交记录
 * Long meetingSummarySubmitUserId;
 Long meetingSummarySubmitMeetingId;
 String meetingSummarySubmitTitle;
 String meetingSummarySubmitText;
 */
var addMeetingSummary = (data) => axios.post('/api/meeting/addMeetingSummary', searchParams2(data));

/**
 * 得到提交记录
 * meetingSummaryCustomId	是	long	id
 */
var findMeetingSummary = (meetingSummaryCustomId) => axios.get('/api/meeting/findMeetingSummary?meetingSummaryCustomId=' + meetingSummaryCustomId);

/**
 * 查询数字微手册
 * meetingSummaryCustomId	是	long	id
 */
var findManualList = (data) => axios.post('/api/ManualApi/findManualList', searchParams2(data));

/**
 * 查看查询俩学一做列表
 * twoLearnType	否	int	类型
 * twoLearnSecondType	否	int	子类型
 */
var findTwoLearn = (data) => axios.post('/api/TwoLearn/findTwoLearnDetails', searchParams2(data));

/**
 * 两学一做字典查询
 * dataDetName	是	string	字典名 （传：two_learn_type）
 */
var findDataDetList = (data) => axios.post('/api/DataDetApi/findDataDetList', searchParams2(data));

/**
 * 查看详情信息
 * twoLearnId	是	int	主键id
 */
var findTwoLearnById = (data) => axios.post('/api/TwoLearn/findTwoLearnById', searchParams2(data));

/**
 * 考试列表
 * pageIndex	是	int	当前页码
 * pageSize	是	int	每页条数
 * state	否	int	状态 考试状态(0、未开始 1、已开始 2、提前结束 3、已结束 4、草稿)
 */
var examList = (pageIndex, pageSize, state) => axios.get('/api/exam/examList?pageIndex=' + pageIndex + '&pageSize=' + pageSize + '&state=' + state);

/**
 * 开始考核
 * examId	是	long	试卷id
 */
var startExam = (examId) => axios.get('/api/exam/startExam?examId=' + examId);

/**
 * 考试 题目列表
 * examId	是	long	试卷id
 * pageIndex	是	int	第几题
 */
var getQuestionItem = (examId, pageIndex) => axios.get('/api/exam/getQuestionItem?examId=' + examId + '&pageIndex=' + pageIndex);

/**
 * 交卷
 * examId	是	long	试卷id
 * answerList	是	数组	答案数组，长度与题目数量一致
 */
var submitExam = (data) => axios.post('/api/exam/submitExam', searchParams2(data));

/**
 * 得到考试解答
 * examId	是	long	试卷id
 */
var getExamAnswer = (examId) => axios.get('/api/exam/getExamAnswer?examId=' + examId);

/**
 * 党建要闻查找权重排名前三类型
 */
var findImportTypeThree = () => axios.post('/api/ImporNews/findImportTypeThree');

/**
 * 查找党建要闻权重排名前三的要闻（上线状态且是推荐要闻）
 */
var findImportNewsThree = () => axios.post('/api/ImporNews/findImportNewsThree');

/**
 * 根据要闻类别和标题查找要闻
 * importNesTitle	否	string	要闻标题
 * importNewsType	否	long	要闻类型
 * pageIndex	否	int	当前页
 * pageSize	否	int	页大小
 */
var findImportNewByTypeAndTitle = (data) => axios.post('/api/ImporNews/findImportNewByTypeAndTitle', searchParams2(data));

/**
 * 查看我评论的党建要闻
 * importNesTitle	否	string	要闻标题
 * importNewsType	否	long	要闻类型
 * pageIndex	否	int	当前页
 * pageSize	否	int	页大小
 */
var findImportNewsByComment = (data) => axios.post('/api/ImporNews/findImportNewsByComment', searchParams2(data));

/**
 * 查看我收藏的党建要闻
 * importNesTitle	否	string	要闻标题
 * importNewsType	否	long	要闻类型
 * pageIndex	否	int	当前页
 * pageSize	否	int	页大小
 */
var findImportNewsByCollect = (data) => axios.post('/api/ImporNews/findImportNewsByCollect', searchParams2(data));

/**
 * 查看我点赞的党建要闻
 * importNesTitle	否	string	要闻标题
 * importNewsType	否	long	要闻类型
 * pageIndex	否	int	当前页
 * pageSize	否	int	页大小
 */
var findImportNewsByThumb = (data) => axios.post('/api/ImporNews/findImportNewsByThumb', searchParams2(data));

/**
 * 查看回复我的党建要闻
 * importNesTitle	否	string	要闻标题
 * importNewsType	否	long	要闻类型
 * pageIndex	否	int	当前页
 * pageSize	否	int	页大小
 */
var findImportNewsByReComment = (data) => axios.post('/api/ImporNews/findImportNewsByReComment', searchParams2(data));

/**
 * 要闻详情
 * importNewsId	是	long	要闻id
 */
var findImportNewsById = (data) => axios.post('/api/ImporNews/findImportNewsById', searchParams2(data));

/**
 * 点赞要闻
 * importNewsId	是	long	要闻id
 */
var addImportNewsThumb = (data) => axios.post('/api/ImporNews/addImportNewsThumb', searchParams2(data));

/**
 * 取消点赞要闻
 * importNewsId	是	long	要闻id
 */
var deleteImportNewsThumb = (data) => axios.post('/api/ImporNews/deletImportNewsThumb', searchParams2(data));

/**
 * 新增收藏党建要闻
 * importNewsId	是	long	要闻id
 */
var addImportNewCollect = (data) => axios.post('/api/ImporNews/addImportNewCollect', searchParams2(data));

/**
 * 取消新增收藏党建要闻
 * importNewsId	是	long	要闻id
 */
var deleteImportNewCollect = (data) => axios.post('/api/ImporNews/deletImportNewCollect', searchParams2(data));

/**
 * 新增评论
 * importNewsId	是	long	要闻id
 * importNewsCommentText	是	string	评论内容
 */
var addImportNewsCommentFather = (data) => axios.post('/api/ImporNews/addImportNewsCommentFather', JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });

/**
 * 新增回复
 * importNewsId	是	long	要闻id
 * importNewsCommentText	是	string	评论内容
 * importNewsCommentId	是	long	要闻评论回复id
 */
var addImportNewsCommentChild = (data) => axios.post('/api/ImporNews/addImportNewsCommentChild', JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });

/**
 * 新增 （评论或回复）点赞
 * importNewsCommentThumbCommentId	是	long	评论或回复id
 */
var addImportNewsCommentThumb = (data) => axios.post('/api/ImporNews/addImportNewsCommentThumb', searchParams2(data));

/**
 * 取消新增 （评论或回复）点赞
 * importNewsCommentThumbCommentId	是	long	评论或回复id
 */
var deletImportNewsCommentThumb = (data) => axios.post('/api/ImporNews/deletImportNewsCommentThumb', searchParams2(data));

/**
 * 根据标签名，上线时间查找通知公告
 * noticeTitle	否	String	通知标题
 * beginTime	否	Date	通知发布时间
 * endTime	否	Date	通知发布时间
 * pageIndex	否	int	当前页
 * pageSize	否	int	页大小
 */
var findNoticeByTitleAndTime = (data) => axios.post('/api/NoticeApi/findNoticeByTitleAndTime', searchParams2(data));

/**
 * 查看详情信息和下一条数据
 * noticId	是	Long	通知id
 */
var findNoticById = (data) => axios.post('/api/NoticeApi/findNoticById', searchParams2(data));

/**
 * 党政法规返回所有类别
 */
var findStatuteType = () => axios.get('/api/statute/findStatuteType');

/**
 * 法规列表
 * keyword	否	string	关键词
 * type	是	int	类型
 * pageIndex	否	int	当前页
 * pageSize	否	int	页大小
 */
var findStatuteByType = (pageIndex, pageSize, keyword, type) => axios.get('/api/statute/findStatuteByType?pageIndex=' + pageIndex + '&pageSize=' + pageSize + '&keyword=' + keyword + '&type=' + type);

/**
 * 法规详情
 * statuteId	是	string	党政法规主键
 * typeId	是	int	党政法规类别主键
 */
var findStatute = (statuteId, typeId) => axios.get('/api/statute/findStatute?statuteId=' + statuteId + '&typeId=' + typeId);

/**
 * 反腐倡廉类型列表
 * pageIndex	是	int	当前页码
 * pageSize	是	int	每页条数
 */
var findNcTypeList = (pageIndex, pageSize) => axios.get('/api/noCorrupt/findNcTypeList?pageIndex=' + pageIndex + '&pageSize=' + pageSize);

/**
 * 反腐倡廉类型列表
 * pageIndex	是	int	当前页码
 * pageSize	是	int	每页条数
 * typeId	否	long	类型id
 * title	否	string	关键字
 * withMeType	否	int	和我关系 1 我评论的 2 我点赞的3 我收藏的 4 我回复的
 */
var noCorruptList = (pageIndex, pageSize, typeId, title, withMeType) => axios.get('/api/noCorrupt/noCorruptList?pageIndex=' + pageIndex + '&pageSize=' + pageSize + '&typeId=' + typeId + '&title=' + title + '&withMeType=' + withMeType);

/**
 * 反腐倡廉详情
 * id	是	long	id
 */
var findNoCorrupt = (id) => axios.get('/api/noCorrupt/findNoCorrupt?id=' + id);

/**
 * 反腐倡廉评论列表
 * id	是	long	id
 */
var findNoCorruptCommentList = (id) => axios.get('/api/noCorrupt/findNoCorruptCommentList?id=' + id);

/**
 * 反腐倡廉点赞或取消文章
 * noCorruptId	是	long	反腐倡廉id
 */
var addThumbTo = (data) => axios.post('/api/noCorrupt/addThumbTo', searchParams2(data));

/**
 * 反腐倡廉收藏或取消文章
 * noCorruptId	是	long	反腐倡廉id
 */
var addCollect = (data) => axios.post('/api/noCorrupt/addCollect', searchParams2(data));

/**
 * 反腐倡廉点赞或取消文章的评论
 * noCorruptCommentId	是	long	反腐倡廉评论id
 */
var addThumb = (data) => axios.post('/api/noCorrupt/addThumb', searchParams2(data));

/**
 * 反腐倡廉增加评论
 * noCorruptCommentText
 noCorruptCommentCorruptId
 noCorruptCommentId
 */
var addComment = (data) => axios.post('/api/noCorrupt/addComment', JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });

/**
 * 党建先锋列表
 * pageIndex	是	int	当前页码
 * pageSize	是	int	每页条数
 */
var findVanguard = (data) => axios.post('/api/VanguardApi/findVanguard', searchParams2(data));

/**
 * 根据党员名称查找党建先锋
 * vanguardUserInfoName	是	string	党建先锋用户名
 */
var findVanguardList = (data) => axios.post('/api/VanguardApi/findVanguardList', searchParams2(data));

/**
 * 查看党建先锋详情信息和下一篇文章
 * vanguardId	是	Long	党建先锋id
 */
var findVanguardById = (data) => axios.post('/api/VanguardApi/findVanguardById', searchParams2(data));

/**
 * 预备党员公告列表
 * pageIndex	是	int	当前页码
 * pageSize	是	int	每页条数
 * keyword	否	string	查找关键词
 */
var findPartyMemberList = (pageIndex, pageSize, keyword) => axios.get('/api/bcn/findList?pageIndex=' + pageIndex + '&pageSize=' + pageSize + '&keyword=' + keyword);

/**
 * 查找预备党员公告
 *bcnId	是	long	公告id
 */
var findPartyMemberDetail = (bcnId) => axios.get('/api/bcn/findBcn?bcnId=' + bcnId);


/**
 * 查询当前登录用户信息
 */
var findUserInfo = () => axios.get('/api/UserApply/findUserInfo');

/**
 * 信息完善
 * sex	否	int	用户性别(1 男 2女)
 * nation	否	string	民族
 * birthday	否	Date	出生日期
 * idCard	否	string	身份证号
 * joinTime	否	Date	入党时间
 * phone	否	string	联系电话
 * nativePlace	否	string	籍贯
 * companyPost	否	string	工作岗位
 * address	否	string	家庭住址
 * headImg	否	string	头像图片
 * backImg	否	string	背景图片
 */
var updateUserInfo = (data) => axios.post('/api/UserApply/updateUserInfo', searchParams2(data));

/**
 * 图片上传接口
 * upfile	是	file	上传的文件
 */
var uploadImage = (data) => axios.post('/api/fileUpload/uploadImage', searchParams(data), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}});

/**
 * 查询党支部列表
 * branchId	是	int	党支部id
 */
var findBranchList = (branchId) => axios.get('/api/user/findBranchList?branchId=' + branchId);

/**
 * 党员详情(隐藏部分信息)
 * userId	是	int	用户id
 */
var findUserDetailHide = (userId) => axios.get('/api/user/findUserDetailHide?userId=' + userId);

/**
 * 党员用户查询
 * pageIndex	是	int	当前页码
 * pageSize	是	int	每页条数
 * userName	否	String	用户名称
 */
var searchUser = (pageIndex, pageSize, userName) => axios.get('/api/user/searchUser?pageIndex=' + pageIndex + '&pageSize=' + pageSize + '&userName=' + userName);

/**
 * 查看党员列表
 * pageIndex	是	int	当前页码
 * pageSize	是	int	每页条数
 * branchId	是	int	党支部id
 */
var findBranchUserList = (pageIndex, pageSize, branchId) => axios.get('/api/user/findBranchUserList?pageIndex=' + pageIndex + '&pageSize=' + pageSize + '&branchId=' + branchId);

/**
 * 思想笔录列表
 */
var findUserRecordList = (pageIndex, pageSize) => axios.get('/api/Record/findUserRecordList?pageIndex=' + pageIndex + '&pageSize=' + pageSize);

/**
 * 思想笔录草稿列表
 */
var findUserRecordDraftList = (pageIndex, pageSize) => axios.get('/api/Record/findUserRecordDraftList?pageIndex=' + pageIndex + '&pageSize=' + pageSize);

/**
 * 思想笔录详情
 * recordId |否 |int |主键id
 */
var findRecordDetail = (recordId) => axios.get('/api/Record/findRecordDetail?recordId=' + recordId);

/**
 * 添加思想笔录
 * title	是	String	标题
 * text	是	String	正文
 * img	否	String	思想笔录图片
 */
var addRecord = (data) => axios.post('/api/Record/addRecord', JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });

/**
 * 添加思想笔录草稿
 * title	是	String	标题
 * text	是	String	正文
 * img	否	String	思想笔录图片
 */
var addRecordDraft = (data) => axios.post('/api/Record/addRecordDraft', JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });

/**
 * 思想笔录编辑草稿并保存
 * recordDraftId	是	int	草稿id
 * title	是	String	标题
 * text	是	String	正文
 * img	否	String	思想笔录图片
 */
var updataRecordDraft = (data) => axios.post('/api/Record/updataRecordDraft', JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });

/**
 * 思想笔录删除草稿
 * recordDraftId	是	int	草稿id
 */
var deleteRecordDraft = (data) => axios.post('/api/Record/deleteRecordDraft', searchParams2(data));

/**
 * 查看思想笔录草稿详情
 * recordId	否	int	主键id
 */
var findUserRecordDraft = (recordId) => axios.get('/api/Record/findUserRecordDraft?recordDraftId=' + recordId);

/**
 * 查看收件箱列表
 * letterState	是	int	信件状态 -1全部 ，0未读 1 已读
 * pageIndex	否	int	当前页
 * pageSize	否	int	页大小
 */
var findReceivingUserLetterList = (data) => axios.post('/api/UserLetter/findReceivingUserLetterList', searchParams2(data));

/**
 * 查看发送邮件列表
 * pageIndex	否	int	当前页
 * pageSize	否	int	页大小
 */
var findSendUserLetterList = (data) => axios.post('/api/UserLetter/findSendUserLetterList', searchParams2(data));

/**
 * 写信
 * title	是	String	标题
 * text	是	String	正文
 * img	否	String	思想笔录图片
 * anonymous	是	int	是否匿名(0 否 1 是)
 */
var addUserLetter = (data) => axios.post('/api/UserLetter/addUserLetter', JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });

/**
 * 查看邮件详情
 * userLetterId	是	int	邮件id
 */
var findUserLetterById = (data) => axios.post('/api/UserLetter/findUserLetterById', searchParams2(data));

/**
 * 删除邮件
 * userLetterId	是	int	邮件id
 */
var delUserLetter = (data) => axios.post('/api/UserLetter/delUserLetter', searchParams2(data));

/**
 * 删除已读邮件
 */
var deleteReadUserLetter = () => axios.post('/api/UserLetter/deleteReadUserLetter');

/**
 * 查看最近的一次认证记录
 */
var findRecentUserApply = () => axios.get('/api/UserApply/findRecentUserApply');

/**
 * 新增认证
 * userApplyUserName	是	string	用户名
 * userApplyCompany	是	string	用户任职公司
 * userApplyBranchId	是	long	党支部id
 * userApplyPostId	是	long	职务id
 * userApplyDescribe	是	string	申请描述
 * userApplyUrl	是	string	材料地址
 * userApplyUrlName	是	string	材料名称
 */
var addUserApply = (data) => axios.post('/api/UserApply/addUserApply', JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } });

/**
 * 无分页查找职务列表
 */
var findPostListNopage = () => axios.post('/api/Post/findPostListNopage');




/**
 * 查看权重值排名第一的通知公告
 */
var findNoticeFirst = () => axios.post('/api/NoticeApi/findNoticeFirst');

/**
 * 显示权重值最高的前四名党建先锋
 */
var findVanguardFour = (data) => axios.post('/api/VanguardApi/findVanguardFour', searchParams2(data));

/**
 * 活动推荐列表
 * pageIndex	是	int	当前页码
 * pageSize	是	int	每页条数
 */
var recommendList = (pageIndex, pageSize) => axios.get('/api/activity/recommendList?pageIndex=' + pageIndex + '&pageSize=' + pageSize);

/**
 * 专题列表 首页推荐
 * commandNum	否	int	推荐数量
 */
var getSpecialCommand = (commandNum) => axios.get('/api/special/getSpecialCommand?commandNum=' + commandNum);

/**
 * 首页反腐倡廉推荐列表
 */
var noCorruptFindIndex = () => axios.get('/api/noCorrupt/findIndex');

/**
 * 首页精选党课
 */
var courseIndex = () => axios.get('/api/course/index');

/**
 * 获取用户自定义
 */
var userIndexFind = () => axios.get('/api/user/userIndexFind');

/**
 * 编辑用户自定义
 */
var userIndex = (data) => axios.post('/api/user/userIndex', searchParams2(data));

/**
 * 公司列表的接口
 */
var companyOption = () => axios.get('/api/user/companyOption');

/**
 * 获取当前用户是否可以会议发起
 */
var meetingState = () => axios.get('/api/meeting/meetingState');

/**
 * 获取园区域名
 */
var channelUrl = () => axios.get('/api/user/channelUrl');

/**
 *
 * 登录接口
 * phone	是	string	手机号
 * phoneCode	是	string	验证码
 */
var login = (phone, phoneCode,channelId) => axios.post('/api/user/login', `phone=${phone}&phoneCode=${phoneCode}&channelId=${channelId}`);
/**
 *
 * 登录验证码
 * phone	是	string	手机号
 * channelId	long	渠道id
 */
var sendCode = (phone) => axios.post('/api/code/sendMsg', `phone=${phone}&type=1`);


/**
 * 获取oss配置信息
 * url
 */
let getSystemOssByUrl = () => axios.get(`/api/oss/systemOssByUrl?url=${ossUrl}`);

export { courseUpLearn, meetingState, courseRecommendList, courseAllList, courseMyList, courseTypeList, courseDetail, addMyCourse, activityList, myActivity, activityDetail, checkUserActivityState, signUp, recommendList, findTypeList, topicList, topicDetail, getSpecialCommand, meetingList, meetingDetail, addSign, addMeeting, findUserInfoByBranch, addMeetingSummary, findMeetingSummary, findManualList, myCourseForIndex, addMyCourseTime, findTwoLearn, findDataDetList, findTwoLearnById, examList, startExam, getQuestionItem, submitExam, getExamAnswer, findImportTypeThree, findImportNewsThree, findImportNewByTypeAndTitle, findNoticeByTitleAndTime, findNoticById, findImportNewsByComment, findImportNewsByCollect, findImportNewsByThumb, findImportNewsByReComment, findImportNewsById, addImportNewsThumb, deleteImportNewsThumb, addImportNewCollect, deleteImportNewCollect, addImportNewsCommentFather, addImportNewsCommentChild, addImportNewsCommentThumb, deletImportNewsCommentThumb, findStatuteType, findStatuteByType, findStatute, findNcTypeList, noCorruptList, findVanguard, findNoCorrupt, findNoCorruptCommentList, addThumbTo, addCollect, addThumb, addComment, findVanguardFour, findPartyMemberList, findPartyMemberDetail, findUserInfo, findVanguardList, findVanguardById, updateUserInfo, uploadImage, findBranchList, findBranchUserList, findUserRecordList, findUserRecordDraftList, findRecordDetail, addRecord, addRecordDraft, findUserRecordDraft, updataRecordDraft, deleteRecordDraft, findReceivingUserLetterList, findSendUserLetterList, addUserLetter, findUserLetterById, deleteReadUserLetter, delUserLetter, searchUser, findUserDetailHide, findRecentUserApply, findPostListNopage, addUserApply, findNoticeFirst, noCorruptFindIndex, courseIndex, userIndexFind, userIndex, getChannelByUrl, companyOption, channelUrl, login, sendCode, getSystemOssByUrl}



// WEBPACK FOOTER //
// ./src/service/getData.js